export const SET_SHOW_MODAL = 'src/store/locationModal/SET_SHOW_VALUE';
